var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysician(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_6441)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1782_6441",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H18V18H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1782_6441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5674 2.27159C11.7439 1.17355 10.4514 0.527344 9.07888 0.527344H8.92071C7.54818 0.527344 6.25577 1.17355 5.43227 2.27159L5.43213 2.27173C5.18146 2.60603 5.0459 3.01257 5.0459 3.43044V5.6109C5.0459 7.79463 6.81612 9.56482 8.99982 9.56482C11.1835 9.56482 12.9537 7.79463 12.9537 5.6109V3.43044C12.9537 3.01257 12.8182 2.60603 12.5675 2.27173L12.5674 2.27159Z",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0459 5.04608H5.04597C5.40759 5.04608 5.7544 4.9024 6.01013 4.64674C6.33518 4.32165 6.74043 3.91641 6.74043 3.91641H6.7405C8.16278 4.62758 9.83685 4.62758 11.2591 3.91641H11.2592C11.2592 3.91641 11.6644 4.32165 11.9895 4.64674C12.2452 4.9024 12.592 5.04608 12.9537 5.04608H12.9537",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 17.4727C17.4727 17.4727 16.7831 15.4041 16.2838 13.9061C15.9701 12.9649 15.1856 12.2574 14.2172 12.0422C12.7229 11.7101 10.6945 11.2594 10.6945 11.2594L9 14.0836L7.30547 11.2594C7.30547 11.2594 5.27709 11.7101 3.78285 12.0422C2.81443 12.2574 2.02992 12.9649 1.71619 13.9061C1.21686 15.4041 0.527344 17.4727 0.527344 17.4727",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30566 11.2593V9.27143",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6943 11.2593V9.27143",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_6441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysician);
export default __webpack_public_path__ + "static/media/Physician.a135e2c68af0d022d1e0f4055337554c.svg";
export { ForwardRef as ReactComponent };